import checkIsTicketTypeShownInQuery from './checkIsTicketTypeShownInQuery';

export default function checkIsTicketTypeVisible(ticketType = {}, query = {}) {
  if (ticketType.hidden) {
    const isTicketTypeShownInQuery = checkIsTicketTypeShownInQuery(ticketType.reference, query);

    if (isTicketTypeShownInQuery) return true;

    return false;
  }

  if (ticketType.availabilityStatus === 'sold_out' && ticketType.hideWhenSoldOut) {
    return false;
  }

  return true;
}
